export function Div2Floor(num) {
  return (num | 0) >> 1;
}
